import http from "@/settings/apiSettings"

class CrmZileDisponibilitateDataService {
  save(data: any): Promise<any> {
    return http.clientComercialOdata.post("/CRM_ZileDisponibilitate", data);
  }

}

export default new CrmZileDisponibilitateDataService();
